<template>
    <div class="mx-auto">
        <b-modal
            ref="modal-comunicacao-transferencia"
            id="modal-comunicacao-transferencia"
            size="xl"
            :content-class="'shadow ' + getTheme"
            :title="'Requisição n. ' + itemCarregado.numeroRequisicao"
            header-bg-variant="success"
            header-text-variant="white"
            @hidden="close">
            <template #modal-header="{ close }">
                <h5 class="modal-title">{{ 'Requisição n. ' + itemCarregado.numeroRequisicao }}</h5>
                <b-button variant="success" @click="relatorioPDFComunicacaoTransferencia" class="py-0 ml-auto"> <i class="far fa-file-pdf"></i> Imprimir</b-button>
                <button class="close text-white ml-1" @click="close()" aria-label="close">&times;</button>
            </template>
            <b-row>
                <b-col xs="12" md="12" class="mx-auto">
                    <div id="messages" v-if="messageModal.message !== null">
                        <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
                    </div>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-card>
                        <b-tabs card active-nav-item-class="text-title-selected">
                            <b-tab title="Dados Básicos" active title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Tipo da Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <p>{{ comunicacaoTransferencia.tipoRequisicao }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Data Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.dataCriacao }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Status Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p :style="'color: ' + comunicacaoTransferencia.corStatus">{{ comunicacaoTransferencia.status }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Forma de Pgto.:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.formaPagamento }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Tipo de Pgto:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.tipoPagamento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Modalidade Parc.:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p> </p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Qtde. Parcelas:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p> </p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Vlr. da Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>R$ {{ comunicacaoTransferencia.valor | currency }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Percentual Pago:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p v-if="comunicacaoTransferencia.quitada">100%</p>
                                        <p v-if="!comunicacaoTransferencia.quitada && comunicacaoTransferencia.status != 'Encaminhada CES'">0.00%</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Origem Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.cnj }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Índice de reajuste:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p></p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Setor Emitente:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.setor }}</p>
                                    </b-col>
                                </b-row>
                                <hr class="mt-3"/>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Observações:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <pre><p class="texto-scroll" v-html="comunicacaoTransferencia.observacoes"></p></pre>
                                    </b-col>
                                </b-row>
                                <hr class="mt-3"/>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="3" md="2">
                                        <label>Docs. Anexados:</label>
                                    </b-col>
                                    <b-col sm="6" md="7">
                                        <span v-for="anexo in comunicacaoTransferencia.anexos" :key="anexo.codAnexo">
                                        <p>
                                            <a class="link" @click="obterAnexo(anexo)">
                                                {{ anexo.nomeAnexo }}
                                            </a>
                                            <b-button class="ml-2" v-if="perfilAdministrador"
                                                    variant="outline-warning"
                                                    @click="removerAnexo(anexo)">
                                                <i class="fa fa-trash"></i>
                                            </b-button>
                                        </p>
                                        </span>
                                    </b-col>
                                    <b-col sm="3" md="3">
                                        <b-button variant="outline-warning" @click="incluirAnexo" class="float-right"> <i class="fa fa-paperclip fa-flip-horizontal"></i> Anexar Arquivo</b-button>
                                        <b-form-file v-show="false" @input="realizarUpload" ref="incluir-anexo"></b-form-file>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Devedor" title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Devedor:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.contribuinte.nome }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>CPF/ CNPJ:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.contribuinte.documento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>E-mail principal:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.contribuinte.email }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Celular:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.contribuinte.telefone }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Endereço:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.contribuinte.logradouro }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Nº:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.contribuinte.numero }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Complemento:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <p>{{ comunicacaoTransferencia.contribuinte.complemento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Cidade:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.contribuinte.municipio != null ? comunicacaoTransferencia.contribuinte.municipio.nome : '' }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Estado:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.contribuinte.uf != null ? comunicacaoTransferencia.contribuinte.uf.nome : '' }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>CEP:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ comunicacaoTransferencia.contribuinte.cep }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="12">
                                        <b-button variant="outline-primary" style="float: right;" @click="atualizarCadastro">
                                            <i class="far fa-address-book fa-flip-horizontal icon-button align-middle"></i> Abrir Cadastro do Devedor
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Pagamento(s)" title-link-class="text-title" v-if="comunicacaoTransferencia.status != 'Encaminhada CES'">
                                <b-row sm="12" md="12" class="d-block">
                                    <b-button variant="outline-primary" @click="enviarEmail" class="mr-2"
                                        :title="'Enviar documentação ao devedor'"
                                    >
                                        <i class="far fa-envelope"></i> Enviar por E-mail
                                    </b-button>
                                    <b-button variant="secondary" v-b-modal.modal-cancelar-comunicacao :disabled="desabilitarCancelarEditar()" class="float-right"
                                        title="O botão Cancelar a Requisição permite o cancelamento da Requisição gerada cuja situação seja Aguardando Validação."
                                    >
                                        <i class="fa fa-trash"></i> Cancelar a Requisição
                                    </b-button>
                                    <b-button variant="warning" class="mr-2 float-right" @click="alterarComunicacaoTransferencia" :disabled="desabilitarCancelarEditar()" v-if="exibirEditar"
                                        title="O botão Editar a Requisição permite editar os parâmetros da Requisição gerada cuja situação seja Aguardando Validação."
                                    >
                                        <i class="fa fa-pen"></i> Editar a Requisição
                                    </b-button>
                                </b-row>
                                <b-row class="mt-3 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>{{ getTituloTabela }}</label>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-table
                                            id="pagamentos"
                                            ref="tablePagamentos"
                                            :items="getItensPagamento"
                                            :fields="getFieldsPagamento"
                                            striped
                                            small
                                            responsive="sm"
                                            :busy="false"
                                            show-empty
                                            hover
                                            bordered
                                            sort-icon-left
                                            class="mb-0 col-12 tabelaModal"
                                            head-variant="light">
                                        <div slot="table-busy" class="text-center text-primary my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong> Carregando...</strong>
                                        </div>
                                        <template slot="empty">
                                            <p class="my-auto">Nenhum tipo de pagamento encontrado.</p>
                                        </template>
                                        <template v-slot:cell(valor)="{ item }">
                                            {{ item.valor | currency }}
                                        </template>
                                    </b-table>
                                </b-row>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-secondary mr-auto" @click=hide()> <i class="fa fa-reply"></i> Voltar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-cancelar-comunicacao"
                id="modal-cancelar-comunicacao"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Cancelar a Requisição"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja cancelar a requisição?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-cancelar-comunicacao')"> Não</b-button>
                <b-button variant="primary" @click="cancelarRequisicao"> Sim</b-button>
            </template>
        </b-modal>

        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="loading"
                @salvarDevedor="salvarDevedor"/>

        <ModalEnviarEmail
                ref="modalEnviarEmail"
                :anexos="comunicacaoTransferencia.anexos"
                :loading="loading"
                @enviarEmail="enviarEmail"/>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import ModalEnviarEmail from "../../shared/components/ModalEnviarEmail";

    export default {
    props: ['loading'],
    components: { ModalAlterarDevedor, ModalEnviarEmail },
    mixins: [ formatarMixins ],
    data() {
        return {
            updated: false,
            urlApi: null,
            token: null,
            exibirEditar: false,
            perfilAdministrador: false,
            dados: {
                uf: [],
                municipios: []
            },
            messageModal: {
                message: null,
                variant: null
            },
            itemCarregado: {
                numeroRequisicao: null
            },
            comunicacaoTransferencia: {
                codComunicacaoTransferencia: null,
                tipoRequisicao: null,
                dataCriacao: null,
                status: null,
                corStatus: null,
                formaPagamento: null,
                tipoPagamento: null,
                valor: null,
                quitada: null,
                observacoes: null,
                anexos: [],
                contribuinte: {
                    codContribuinte: null,
                    tipoContribuinte: {
                        id: null,
                        nome: null
                    },
                    nome: null,
                    indAtivo: null,
                    documento: null,
                    telefone: null,
                    email: null,
                    cep: null,
                    logradouro: null,
                    numero: null,
                    complemento: null,
                    bairro: null,
                    uf: {
                        id: null,
                        nome: null
                    },
                    municipio: {
                        codMunicipio: null,
                        nome: null
                    },
                }
            }
        }
    },
    computed: {
        getFieldsPagamento () {
            return [
                {
                    key: 'dataTransferencia',
                    label: 'Data da Transf.'
                },
                {
                    key: 'valor',
                    label: 'Valor'
                },
                {
                    key: 'validadoSetor',
                    label: 'Validação GOFS'
                },
                {
                    key: 'validadoTesoureiro',
                    label: 'Validação Tesoureiro'
                },
                {
                    key: 'status',
                    label: 'Situação'
                }
            ]
        },
        getItensPagamento () {
             return [ this.comunicacaoTransferencia ]
        },
        getTheme () {
            return this.$store.getters.getTheme
        },
        getTituloTabela () {
            return 'Transferência:'
        }
    },
    methods: {
        abrirExtrato(item) {
            this.limparMsgsModal();

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/carregarExtrato/${item.tabelaOrigem}/${item.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.itemCarregado = item;
                this.comunicacaoTransferencia = {
                    ...response.data,
                    id: item.id
                }
                this.$refs['modal-comunicacao-transferencia'].show();
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            });
        },
        async obterAnexo(anexo) {
            await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
            }).then(response => {
                if(!response.data || response.data == null){
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                    return;
                }

                var a = document.createElement("a");
                a.href = response.data.base64;
                a.download = response.data.nomeArquivo;
                a.click();
            }).catch((error) => {
                this.exibirErro(error)
            });
        },
        async relatorioPDFComunicacaoTransferencia() {
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/exportarComunicacaoTransferencia/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
            .then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'ComunicacaoTransferencia' + this.itemCarregado.numeroRequisicao + '.pdf';
                link.click();
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        cancelarRequisicao() {
            this.$refs['modal-cancelar-comunicacao'].hide();

            this.limparMsgsModal();

            if(this.comunicacaoTransferencia.status != 'Aguardando Aprovação' &&
                this.comunicacaoTransferencia.status != 'Aguardando Validação' &&
                this.comunicacaoTransferencia.status != 'Pendente') {
                this.messageModal = {
                    message: 'Requisição não pode ser cancelada na situação atual.',
                    variant: 'danger'
                };
                return;
            }

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/cancelarComunicacaoTransferencia/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                this.updated = true;
                this.abrirExtrato(this.itemCarregado);
                this.messageModal = {
                    message: 'Requisição cancelada com sucesso.',
                    variant: 'success'
                };
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        alterarComunicacaoTransferencia() {
            this.limparMsgsModal();

            if(this.comunicacaoTransferencia.status != 'Aguardando Aprovação' &&
                this.comunicacaoTransferencia.status != 'Aguardando Validação' &&
                this.comunicacaoTransferencia.status != 'Pendente') {
                this.messageModal = {
                    message: 'Requisição não pode ser alterada na situação atual.',
                    variant: 'danger'
                };
                return;
            }

            if(this.$router.currentRoute.fullPath.startsWith('/comunicacao-transferencia')) {
                this.$emit('obterComunicacaoTransferencia', this.itemCarregado.id, false);
                this.$refs['modal-comunicacao-transferencia'].hide();
            } else {
                this.$store.commit('setComunicacaoTransferencia', this.itemCarregado.id);
                this.$router.push({path: '/comunicacao-transferencia'});
            }
        },
        atualizarCadastro() {
            this.$refs.modalAlterarDevedor.atualizarCadastro(this.comunicacaoTransferencia.contribuinte);
        },
        enviarEmail () {
            this.$refs.modalEnviarEmail.abrirModalEnviarEmail(this.comunicacaoTransferencia)
        },
        incluirAnexo () {
            this.$refs['incluir-anexo'].$el.childNodes[0].click()
        },
        realizarUpload (arquivo) {
            this.limparMsgsModal()
            let arquivoConvertido = null
            /* if (!arquivo.name.endsWith(".jpeg")
                && !arquivo.name.endsWith(".jpg")
                && !arquivo.name.endsWith(".png")
                && !arquivo.name.endsWith(".pdf")) {
                this.messageModal = {
                    message: 'Formato do arquivo inválido.',
                    variant: 'danger'
                }
            } else */ if ((arquivo.size / 1024) / 1024 > 50.0) {
                this.messageModal = {
                    message: 'O tamanho do arquivo ultrapassa o limite permitido pelo sistema (50Mb)!',
                    variant: 'danger'
                }
            } else {
                var reader = new FileReader()
                reader.onload = function (e) {
                    arquivoConvertido = {
                        nomeArquivo: arquivo.name,
                        base64: e.target.result
                    }
                }
                reader.readAsDataURL(arquivo)
                reader.onloadend = () => this.salvarAnexo(arquivoConvertido)
            }
        },
        salvarAnexo (arquivo) {
            let parametros = {
                id: this.comunicacaoTransferencia.id,
                arquivo: arquivo,
                tipoOrigem: this.comunicacaoTransferencia.tipoOrigem
            }

            this.loading.showLoading()
            axios.post(`${this.urlApi}/v1/pesquisas/incluirAnexo`, parametros, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then((response) => {
                let codAnexo = ((response) && (response.data)) ? response.data.id : 0
                this.comunicacaoTransferencia.anexos.push({
                    codAnexo: codAnexo,
                    nomeAnexo: arquivo.nomeArquivo,
                    base64 : arquivo.base64
                })
                this.loading.hideLoading()
            }).catch((error) => {
                this.exibirErro(error)
                this.loading.hideLoading()
            })
        },
        removerAnexo (arquivo) {
            this.loading.showLoading()
            axios.post(`${this.urlApi}/v1/pesquisas/removerAnexo/${arquivo.codAnexo}`, null, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then((response) => {
                this.comunicacaoTransferencia.anexos = this.comunicacaoTransferencia.anexos.filter((anexo) => anexo.codAnexo !== arquivo.codAnexo)
                this.loading.hideLoading()
            }).catch((error) => {
                this.exibirErro(error)
                this.loading.hideLoading()
            })
        },
        salvarDevedor(contribuinte) {
            this.comunicacaoTransferencia.contribuinte = {
                codContribuinte: contribuinte.codContribuinte,
                nome: contribuinte.nome,
                documento: contribuinte.documento,
                telefone: contribuinte.telefone,
                telefoneAlternativo1: contribuinte.telefoneAlternativo1,
                telefoneAlternativo2: contribuinte.telefoneAlternativo2,
                email: contribuinte.email,
                emailAlternativo1: contribuinte.emailAlternativo1,
                emailAlternativo2: contribuinte.emailAlternativo2,
                cep: contribuinte.cep,
                logradouro: contribuinte.logradouro,
                numero: contribuinte.numero,
                complemento: contribuinte.complemento,
                bairro: contribuinte.bairro,
                uf: contribuinte.uf,
                municipio: contribuinte.municipio
            };
            this.messageModal = {
                message: 'Cadastro do Devedor alterado com sucesso!',
                variant: 'success'
            };
            this.updated = true;
        },
        verificarObrigatoriedade() {
            return !(this.verificarValorVazio(this.contribuinte.nome) ||
                this.verificarValorVazio(this.contribuinte.documento));
        },
        limparMsgsModal() {
            this.messageModal = {
                message: null,
                variant: null
            };
        },
        close() {
            this.$emit('closeModal', this.updated);
            this.updated = false;
        },
        requisicaoCancelada() {
            return this.comunicacaoTransferencia != null && this.comunicacaoTransferencia.status == 'Cancelada';
        },
        desabilitarCancelarEditar() {
            return this.comunicacaoTransferencia != null && this.comunicacaoTransferencia.status != 'Aguardando Aprovação' &&
                this.comunicacaoTransferencia.status != 'Aguardando Validação' &&
                this.comunicacaoTransferencia.status != 'Pendente';
        }
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        let userData = JSON.parse(this.$store.getters.getUser);
        if (userData.groups) {
            for (let i = 0; i < userData.groups.length; i++) {
                if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR' || userData.groups[i] == 'SFEPGE-TESOUREIRO') {
                    this.exibirEditar = true;
                }
                if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR') {
                    this.perfilAdministrador = true;
                }
            }
        }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

.icon-button {
    font-size: 1.5rem;
}

</style>
